package org.moxultimate.topwithmox.components.navbar

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors.LightGray
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.HamburgerIcon
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import org.jetbrains.compose.web.css.*
import org.moxultimate.topwithmox.components.buttons.IconButton
import org.moxultimate.topwithmox.components.texts.TextNavLink
import org.moxultimate.topwithmox.core.toggle.FeatureToggle.DASHBOARD_GAME_APP_TOGGLE
import org.moxultimate.topwithmox.core.toggle.FeatureToggle.DASHBOARD_PRODUCT_TOGGLE
import org.moxultimate.topwithmox.core.toggle.FeatureToggle.DASHBOARD_SHOWS_TOGGLE
import org.moxultimate.topwithmox.core.toggle.FeatureToggle.DASHBOARD_TECH_TOGGLE
import org.moxultimate.topwithmox.navigation.NavRoute
import org.moxultimate.topwithmox.theme.SemiWhiteTransparentBG

@Composable
fun NavBar(onOpenSideNav: () -> Unit = {}) {

    // Breakpoint or target size for hiding the top menu and showing side nav bar
    val breakPointForSideNavBarVisibility = Breakpoint.LG

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(74.px)
            .flexWrap(FlexWrap.Wrap)
            .position(Position.Fixed)         // Keeps it stuck to the top during scroll
            .zIndex(100)              // High z-index to stay above main content
            .background(SemiWhiteTransparentBG)
            .borderBottom(
                width = 1.px,
                style = LineStyle.Solid,
                color = LightGray,
            )
        ,
        verticalAlignment = Alignment.CenterVertically
    ) {
        TopWithMoxLogo()

        Spacer()

        NavBarMenu(breakPoint = breakPointForSideNavBarVisibility)

        SideNavBarMenu(breakPoint = breakPointForSideNavBarVisibility, onOpen = onOpenSideNav)
    }
}

@Composable
private fun TopWithMoxLogo() {
    Image(
        src = "/logo_topwithmox.webp",
        description = "Top With Mox Logo",
        modifier = Modifier
            .height(3.5.cssRem)
            .padding(left = 30.px)
            .display(DisplayStyle.Block)
    )
}

@Composable
private fun NavBarMenu(breakPoint: Breakpoint) {
    Row(
        Modifier
            .gap(2.cssRem)
            .padding(leftRight = 3.cssRem)
            .displayIfAtLeast(breakPoint),
        verticalAlignment = Alignment.CenterVertically
    ) {
        NavBarMenuItems()
    }
}


/*
*  Make sure to also add the items here in the SideNavMenuItems in NavBar
*/
@Composable
fun NavBarMenuItems() {
    TextNavLink(
        path = NavRoute.DASHBOARD,
        text = "Home",
        fontSize = 16
    )
    TextNavLink(
        path = NavRoute.WALLPAPER,
        text = "Top Wallpapers",
        fontSize = 16
    )
    TextNavLink(
        path = NavRoute.APPS,
        text = "Top Games & Apps",
        fontSize = 16,
        disabled = !DASHBOARD_GAME_APP_TOGGLE
    )
    TextNavLink(
        path = NavRoute.SHOWS,
        text = "Top Shows",
        fontSize = 16,
        disabled = !DASHBOARD_SHOWS_TOGGLE
    )
    TextNavLink(
        path = NavRoute.TECH,
        text = "Top Tech",
        fontSize = 16,
        disabled = !DASHBOARD_TECH_TOGGLE
    )
    TextNavLink(
        path = NavRoute.PRODUCTS,
        text = "Top Products",
        fontSize = 16,
        disabled = !DASHBOARD_PRODUCT_TOGGLE
    )
    TextNavLink(
        path = NavRoute.ABOUT,
        text = "About",
        fontSize = 16,
    )
}


@Composable
private fun SideNavBarMenu(breakPoint: Breakpoint, onOpen: () -> Unit) {
    Row(
        Modifier
            .fontSize(1.5.cssRem)
            .gap(1.cssRem)
            .margin(right = 20.px)
            .displayUntil(breakPoint),
        verticalAlignment = Alignment.CenterVertically
    ) {
        HamburgerButton(onClick = { onOpen() })
    }
}


@Composable
private fun HamburgerButton(onClick: () -> Unit) {
    IconButton(onClick) {
        HamburgerIcon()
    }
}




